import React, { useState, useEffect } from 'react';
import './rpt_ejecucion_tabla.css'

const TablaEjecucionBloque = (p) => {
    const [seleccionesLocal, setseleccionesLocal] = useState({ index: -1 });
    const [reporteFormato, setreporteFormato] = useState([]);

    useEffect(() => {
        setseleccionesLocal({ index: -1 });
        formatearReporte();
    }, [p.datos]);

    const formatearReporte = () => {
        const datos = p.datos ?? [];
        const formato = {};
        for (const item of datos) {
            if (!formato[item.bloque]) {
                formato[item.bloque] = {
                    bloque: item.bloque,
                    total_plan: 0,
                    total_ejecutado: 0,
                    total_semanas: 0,
                    ranchos: {},
                    valvulas: {},
                    semanas_array: [],
                    semanas: {}
                };
            }
            formato[item.bloque].total_plan += item.plan_plantas ?? 0;
            formato[item.bloque].total_ejecutado += item.total_plantas ?? 0;
            const semana = item.semana_trasplante;

            if (!formato[item.bloque].semanas[semana]) {
                formato[item.bloque].semanas[semana] = {
                    semana: semana,
                    total_plan: 0,
                    total_ejecutado: 0,
                    datos: []
                };
                formato[item.bloque].total_semanas += 1;
                formato[item.bloque].semanas_array.push(semana);
            }
            formato[item.bloque].ranchos[item.rancho] = true;
            formato[item.bloque].valvulas[item.valvula] = true;
            formato[item.bloque].semanas[semana].total_plan += item.plan_plantas ?? 0;
            formato[item.bloque].semanas[semana].total_ejecutado += item.total_plantas ?? 0;
            formato[item.bloque].semanas[semana].datos.push(item);
        }
        setreporteFormato(Object.values(formato));
    }

    const formatoCommas = (numero) => {
        if (numero === null || numero === undefined || Number.isNaN(Number(numero))) {
            return '0';
        }

        return Number(numero).toLocaleString('en-US');
    }

    return (
        <table className='table table-sm' >
            <thead>
                <tr>
                    <th scope='col' className='text-start'>BLOQUE</th>
                    <th scope='col' className='text-end'>PLAN.</th>
                    <th scope='col' className='text-end'>EJECUTADO</th>
                    <th scope='col' className='text-center'>AVANCE</th>
                    <th scope='col' className='text-center'>RANCHOS</th>
                    <th scope='col' className='text-center'>VALVULAS</th>
                    <th scope='col' className='text-center'>SEMANAS</th>
                </tr>
            </thead>
            <tbody>
                {reporteFormato.length === 0 && (
                    <tr>
                        <td colSpan="7" className="text-center th h2 text-300">No hay datos disponibles</td>
                    </tr>
                )}
                {
                    reporteFormato.map((bloque, index) => (
                        <React.Fragment key={index}>
                            <tr className={`${seleccionesLocal.index !== -1 && seleccionesLocal.index !== index ? 'tr-semitrasparent' : 'tr'}`}
                                onClick={() => setseleccionesLocal({ index: seleccionesLocal.index === index ? -1 : index })}>
                                <td scope='row' className='th nowrap'>{bloque.bloque}</td>
                                <td className='text-300 text-end th'>{formatoCommas(bloque.total_plan)}</td>
                                <td className='text-bold text-end th'>{formatoCommas(bloque.total_ejecutado)}</td>
                                <td className='text-center th'>{(bloque.total_plan !== 0 ? (bloque.total_ejecutado / bloque.total_plan) * 100 : 0).toFixed(2)}%</td>
                                <td className='text-center th nowrap text-center'>{Object.keys(bloque.ranchos).join(', ')}</td>
                                <td className='text-center th nowrap text-center'>{Object.keys(bloque.valvulas).length}</td>
                                <td className='text-center th nowrap text-center'>{bloque.semanas_array.join(', ')}</td>
                            </tr>
                            {seleccionesLocal.index !== -1 && seleccionesLocal.index === index && (
                                <tr>
                                    <td colSpan="7" className="text-center th">
                                        <table className='table table-sm table-hover text-s'>
                                            <thead>
                                                <tr>
                                                    <th style={{ fontSize: 'small' }} scope='col'>TASPL.</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>CORTE</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>PLAN</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>EJECT.</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>RANCHO</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>VALVULA</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>CAMAS</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>METROS</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>DENSIDAD</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>LUNES</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>MARTES</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>MIÉRCOLES</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>JUEVES</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>VIERNES</th>
                                                    <th style={{ fontSize: 'small' }} scope='col'>SÁBADO</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bloque.semanas_array.map((semana, i) => bloque.semanas[semana].datos.map((bloqueDatos, j) => (
                                                    <tr key={j + "-" + i} style={bloqueDatos.total_plantas < bloqueDatos.plan_plantas ? { 'fontStyle': 'italic', fontWeight: 'bold' } : {}}>
                                                        <td className='text-bold'>{bloqueDatos.semana_trasplante}</td>
                                                        <td >{bloqueDatos.semana_cosecha}</td>
                                                        <td >{bloqueDatos.plan_plantas}</td>
                                                        <td className={bloqueDatos.total_plantas < bloqueDatos.plan_plantas ? 'text-bold text-red3' : ''}>{bloqueDatos.total_plantas}</td>
                                                        <td >{bloqueDatos.rancho}</td>
                                                        <td >{bloqueDatos.valvula}</td>
                                                        <td >{bloqueDatos.cama_inicio} - {bloqueDatos.cama_fin}</td>
                                                        <td >{bloqueDatos.metros2_siembra}</td>
                                                        <td >{bloqueDatos.metros2_siembra > 0 ? Math.round(bloqueDatos.total_plantas / bloqueDatos.metros2_siembra * 100) / 100 : 0}</td>
                                                        <td className={bloqueDatos.lunes ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.lunes)}</td>
                                                        <td className={bloqueDatos.martes ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.martes)}</td>
                                                        <td className={bloqueDatos.miercoles ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.miercoles)}</td>
                                                        <td className={bloqueDatos.jueves ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.jueves)}</td>
                                                        <td className={bloqueDatos.viernes ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.viernes)}</td>
                                                        <td className={bloqueDatos.sabado ? 'text-bold text-blue3' : ''}>{formatoCommas(bloqueDatos.sabado)}</td>
                                                    </tr>
                                                )))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))
                }
            </tbody>
        </table>
    )
}

export default TablaEjecucionBloque;